const base = process.env.REACT_APP_API_URL + "/"
const auth = process.env.REACT_APP_API_URL_AUTH + "/"

const main = {
    advertiser: "advertiser",
    auth: "auth",
    contact: "contact",
    crawler: "crawler",
    customer: "customer",
    event: "event",
    fun: "fun",
    geo: "geo",
    management: "management",
    service: "service",
    offer: "offer",
    office: "office",
    storage: "storage",
    system: "system"
}

const _paths = {
    auth: auth,
    base: base,
    dash: "dashes/",
    advertiser: {
        companies: main.advertiser + "/" + "companies/",
        contacts: main.advertiser + "/" + "contacts/",
        accounts: main.advertiser + "/" + "accounts/",
        addresses: main.advertiser + "/" + "addresses/",
        groups: main.advertiser + "/" + "groups/"
    },
    contacts: {
        phones: main.contact + "/" + "phones/",
    },
    crawler: {
        crawlers: main.crawler + "/" + "crawlers/",
        activities: main.crawler + "/" + "activities/",
        errors: main.crawler + "/" + "errors/",
        alerts: main.crawler + "/" + "alerts/",
        crons: main.crawler + "/" + "crons/",
        accounts: main.crawler + "/" + "accounts/",
        potentials: main.crawler + "/" + "potentials/",
        spiderman: main.crawler + "/" + "spiderman/",
    },
    customer: {
        companies: main.customer + "/" + "companies/",
        users: main.customer + "/" + "users/",
        branches: main.customer + "/" + "branches/",
        groups: main.customer + "/" + "groups/",

        markers: main.customer + "/" + "markers/",
        kanbans: main.customer + "/" + "kanbans/",
        labels: main.customer + "/" + "labels/",

        delegates: main.customer + "/" + "delegates/",
        auths: main.customer + "/" + "auths/",

        clients: main.customer + "/" + "clients/",
    },
    fun: {
        lotto: main.fun + "/" + "lotto/",
    },
    management: {
        admins: main.management + "/" + "admins/",
        banks: main.management + "/" + "banks/",
        billings: main.management + "/" + "billings/",
        clients: main.management + "/" + "clients/",
        gdpr: main.management + "/" + "gdpr/",
        comments: main.management + "/" + "comments/",
    },
    office: {
        invoices: main.office + "/" + "invoices/",
    },
    geo: {
        provinces: main.geo + "/" + "provinces/",
        counties: main.geo + "/" + "counties/",
        communes: main.geo + "/" + "communes/",
	    cities: main.geo + "/" + "cities/",
	    districts: main.geo + "/" + "districts/",
	    streets: main.geo + "/" + "streets/",
	    localization: main.geo + "/" + "localization/",
    },
    offer: {
        browse: main.offer + "/" + "offers/",
        pretenses: main.offer + "/" + "pretenses/",
        verify: main.offer + "/" + "verify/",
    },
    service: {
        orders: main.service + "/" + "orders/",
	    reports: main.service + "/" + "reports/",
	    emails: main.service + "/" + "emails/",
    },
    storage: {
        app: main.storage + "/" + "app/",
        logs: main.storage + "/" + "logs/",
        document: main.storage + "/" + "document/",
    },
    system: {
        errors: main.system + "/" + "error/",
        hints: main.system + "/" + "hints/",
        logs: main.system + "/" + "logs/",
        receivingBooks: main.system + "/" + "receiving-book/",
        records: main.system + "/" + "records/",
        reports: main.system + "/" + "reports/",
        portals: main.system + "/" + "portals/",
        translations: main.system + "/" + "translations/",
    },
    event: main.event + "/",
}

export default _paths
